// Import the functions you need from the SDKs you need
import React from "react";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  getAuth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
} from "firebase/auth";
//import { getAnalytics } from "firebase/analytics";
import { createContext } from "react";

export const FirebaseContext = createContext();
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

//const analytics = getAnalytics(app);

function FirebaseContextProvider(props) {
  const auth = getAuth(app);
  const storage = getStorage(app);
  const db = getFirestore(app);

  function doSignInWithEmailAndPassword(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function doSignOut() {
    auth.signOut();
  }
  function doPasswordReset(email) {
    auth.sendPasswordResetEmail(email);
  }
  function doPasswordUpdate(password) {
    auth.currentUser.updatePassword(password);
  }

  return (
    <FirebaseContext.Provider
      value={{
        auth,
        db,
        storage,
        doSignInWithEmailAndPassword,
        doSignOut,
        doPasswordReset,
        doPasswordUpdate,
      }}
    >
      {props.children}
    </FirebaseContext.Provider>
  );
}

export default FirebaseContextProvider;
